/**
 * Public Route Component
 * 
 * Allows access to routes without authentication (for singleapp-public portals).
 * Still renders within the app layout (header/navigation) but shows Login/SignUp buttons
 * instead of requiring authentication.
 * 
 * Used for pages like: Home, ProductCatalog, ProductDetail, Cart (public shop pages)
 */

import React from 'react';
import { useAuth } from '../contexts/AuthContext';

/**
 * PublicRoute Component
 * 
 * @param {ReactNode} children - Component to render (accessible without login)
 * @param {ReactNode} loadingComponent - Component to show while loading (optional)
 */
const PublicRoute = ({ 
  children, 
  loadingComponent = null 
}) => {
  const { isLoading, isInitialized } = useAuth();
  
  // Show loading state while initializing auth (but don't block rendering)
  if (!isInitialized || isLoading) {
    if (loadingComponent) {
      return loadingComponent;
    }
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }
  
  // Render children regardless of authentication status
  // The Header/Navigation components will adapt based on auth status
  return children;
};

export default PublicRoute;

